import { useCallback, useEffect, useState } from "react";
import { VerlaufButton, VerlaufKomplett } from "./LinienführungAnlegenCss";

export default function RückrichtungAnalog({ hrCollection, rrCollection, setRrCollection }) {
    const [updateRr, setUpdateRr] = useState(false);
    const [useAnalog, setUseAnalog] = useState(false);
    //komische Zwischenlösung, weil kein Zugriff auf rrCollection.rrAnalog im Callback...whatever

    function updateAnalog(e) {
        setUseAnalog(e.target.checked);
        setRrCollection({
            ...rrCollection,
            rrAnalog: e.target.checked
        });
        if (!e.target.checked) {
            setRrCollection({
                ...rrCollection,
                rrAnalog: e.target.checked,
                rrStreckenId: undefined,
                rrHalte: {},
                rrVerlauf: [],
                mirrored: undefined,
                bisherigeStrNutzen: false,
                neueStrecke: false
            });
        }
    }

    const handleCopyingHrChanges = useCallback((rrCollection) => {
        if (useAnalog) {
            const verlauf = hrCollection.hrVerlauf.map(station => ({ ...station }));
            setRrCollection({
                ...rrCollection,
                rrStreckenId: hrCollection.hrStreckenId,
                rrHalte: { ...hrCollection.hrHalte },
                rrVerlauf: verlauf,
                mirrored: !hrCollection.mirrored,
                rrAnalog: true,
                bisherigeStrNutzen: false,
                neueStrecke: false
            });
        }
    }, [hrCollection, setRrCollection, useAnalog]);

    useEffect(() => {
        handleCopyingHrChanges();
    }, [hrCollection, handleCopyingHrChanges]);

    function changeUpdateRr(e) {
        e.preventDefault();
        setUpdateRr(!updateRr);
    }

    const orderingVerlauf = (ext_verlauf, mirror) => {
        if (mirror) {
            return [...ext_verlauf].sort((a, b) => a.pos < b.pos)
        } else {
            return [...ext_verlauf].sort((a, b) => a.pos > b.pos)
        }
    }

    const updateVerlauf = (e) => {
        e.preventDefault();
        handleVerlaufChange(e.target.id);
    }

    function handleVerlaufChange(bhfPos) {
        let completeStation = rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        let currentState = completeStation.verlauf;
        completeStation.verlauf = !currentState;
        if (!currentState) {
            // nur wenn verlauf auf ja, dann halt auch
            handleHalteChange(bhfPos, true);
        }
        let completeVerlauf = rrCollection.rrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setRrCollection({
            ...rrCollection,
            rrVerlauf: completeVerlauf
        });
    }

    function updateHalte(e) {
        handleHalteChange(e.target.value, e.target.checked);
    }

    function handleHalteChange(bhfPos, newState) {
        let currentHalte = rrCollection.rrHalte;
        currentHalte[bhfPos] = newState;
        if (!newState) {
            // wenn auf nein, dann auch verlauf nein
            setVerlaufFalse(bhfPos);
        }
        setRrCollection({
            ...rrCollection,
            rrHalte: currentHalte
        });
    }
    function setVerlaufFalse(bhfPos) {
        let completeStation = rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhfPos))[0];
        completeStation.verlauf = false;
        let completeVerlauf = rrCollection.rrVerlauf.filter(station => station.pos !== parseInt(bhfPos));
        completeVerlauf.push(completeStation);

        setRrCollection({
            ...rrCollection,
            rrVerlauf: completeVerlauf
        });
    }

    return (
        <div className="rr-variante">
            <label>
                <input type="checkbox" checked={rrCollection.rrAnalog} onChange={(e) => updateAnalog(e)} />
                analog zur Hinrichtung
            </label>
            {rrCollection.rrAnalog && <div style={{ border: "1px  solid darkcyan", padding: "1em", marginLeft: "1em" }}>
                {updateRr && 
                    <VerlaufKomplett>
                        <thead>
                            <tr>
                                <th>in Verlaufsbeschreibung</th>
                                <th>Halt</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderingVerlauf(rrCollection.rrVerlauf, true).map(bhf =>
                                <tr key={bhf.pos}>
                                    <td>
                                    {/* verlauf */}
                                    <VerlaufButton id={bhf.pos} value={bhf.pos} onClick={(e) => updateVerlauf(e)}
                                        className={rrCollection.rrVerlauf.filter(station => station.pos === bhf.pos)[0].verlauf ? "active" : "inactive"}>
                                        <span id={bhf.pos}>{bhf.pos}: </span>{bhf.bhf}</VerlaufButton>
                                        </td>
                                    {/* halte */}
                                    <td>
                                    <input type="checkbox" value={bhf.pos} onChange={(e) => updateHalte(e)}
                                        // disabled={!rrCollection.rrVerlauf.filter(station => station.pos === parseInt(bhf.pos))[0].verlauf}
                                        checked={rrCollection.rrHalte[bhf.pos]} />
                                        </td>
                                </tr>
                            )}
                        </tbody></VerlaufKomplett>
                }
                <button onClick={(e) => changeUpdateRr(e)}>&#9998; {updateRr ? 'So übernehmen' : `Bearbeiten`}</button>
                <div>
                    <label>gewählter Verlauf:</label>
                    <div style={{ fontSize: 'small', marginLeft: "2em" }}>
                        {orderingVerlauf(rrCollection.rrVerlauf, true)
                            .filter(b => b.verlauf)
                            .map(bhf => `-${bhf.bhf}-`)}
                    </div>
                </div>
            </div>}
        </div>
    )
}